import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { BookOpen, Search } from "lucide-react";
import { GLOSSARY } from "@/data/staticData";

export default function GlossaryPage() {
  const [search, setSearch] = useState("");
  const filtered = GLOSSARY.filter(g =>
    g.term.toLowerCase().includes(search.toLowerCase()) ||
    g.definition.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6 max-w-3xl mx-auto" data-testid="glossary-page">
      <div className="mb-6 animate-fade-in">
        <div className="flex items-center gap-3 mb-2">
          <BookOpen className="h-6 w-6 text-[var(--ia-navy)]" />
          <h1 className="text-2xl font-bold text-[var(--ia-text)]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Glossaire</h1>
        </div>
        <p className="text-[var(--ia-text-muted)]">Définitions clés de la conformité IA et RGPD</p>
      </div>

      <div className="relative mb-6 animate-fade-in">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[var(--ia-muted)]" />
        <Input data-testid="glossary-search" placeholder="Rechercher un terme..." value={search} onChange={(e) => setSearch(e.target.value)} className="pl-10" />
      </div>

      <div className="space-y-3">
        {filtered.map((g, i) => (
          <Card key={g.term} className="border-[var(--ia-border)] animate-fade-in" style={{ animationDelay: `${i * 40}ms` }} data-testid={`glossary-${g.term}`}>
            <CardContent className="p-4">
              <h3 className="text-sm font-semibold text-[var(--ia-navy)] mb-1">{g.term}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{g.definition}</p>
            </CardContent>
          </Card>
        ))}
        {filtered.length === 0 && (
          <p className="text-center text-[var(--ia-muted)] text-sm mt-8">Aucun terme trouvé pour "{search}"</p>
        )}
      </div>
    </div>
  );
}
